<div>
  <div class="mb-4 flex justify-between items-center">
    <mat-form-field>
      <mat-label>Search All Clients</mat-label>
      <input matInput [formControl]="searchControl" />
    </mat-form-field>
    <button
      *ngIf="!isOrdersManager() && !isOrdersAdmin()"
      mat-flat-button
      color="accent"
      routerLink="/clients/add"
    >
      ADD CLIENT +
    </button>
  </div>

  @if (clientsLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (clientsError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="dataSource"
        [matSortActive]="currentSort.active"
        [matSortDirection]="currentSort.direction"
        matSort
        (matSortChange)="sortData($event)"
        class="w-full"
      >
        <!-- Company Column -->
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Company
          </th>
          <td mat-cell *matCellDef="let client" class="border-b p-4">
            {{ client.company }}
          </td>
        </ng-container>

        <!-- Contact Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Contact Person
          </th>
          <td mat-cell *matCellDef="let client" class="border-b p-4">
            {{ client.contact }}
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Email
          </th>
          <td mat-cell *matCellDef="let client" class="border-b p-4">
            {{ client.email }}
          </td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-left">Phone</th>
          <td mat-cell *matCellDef="let client" class="border-b p-4">
            {{ client.phone }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24">
            <!-- Empty header for actions column -->
          </th>
          <td mat-cell *matCellDef="let client" class="border-b p-4 text-right">
            <div class="invisible group-hover:visible flex items-center gap-2">
              <button
                *ngIf="!isOrdersManager() && !isOrdersAdmin()"
                mat-icon-button
                matTooltip="Edit Client"
                (click)="editClient(client); $event.stopPropagation()"
                class="text-gray-700"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="hover:bg-gray-100 cursor-pointer client-row group"
        ></tr>
      </table>
    </div>

    <ciwc-pagination
      [currentPage]="pageIndex"
      [pageSize]="pageSize"
      [totalItems]="totalClients"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)"
    ></ciwc-pagination>

    <!-- Hidden paginator for functionality -->
    <div class="hidden">
      <mat-paginator
        #paginator
        [length]="totalClients"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="handlePageEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  }
</div>
